function words(s: string): string[] {
  return s
    .toLowerCase()
    .replace(/[^\p{L}\p{N}\s']/gu, ' ')
    .split(/\s+/)
    .filter(Boolean);
}

/**
 * Merge the barge-in seed transcript (fast STT of the first segment) with the interrupt re-STT
 * of the trimmed capture. The capture starts at the same clean cut as the seed, so a re-STT that
 * shares any words with the seed is a re-hearing of the same audio and wins outright. A re-STT
 * with no overlap is treated as a strict continuation and appended to the seed.
 */
export function mergeInterruptTranscript(seed: string, reStt: string): string {
  const s = seed.trim();
  const t = reStt.trim();
  if (!s) return t;
  if (!t) return s;
  const seedWords = new Set(words(s));
  const overlap = words(t).some((w) => seedWords.has(w));
  return overlap ? t : `${s} ${t}`;
}
